export const DELETE_GG_POINT_OF_CONTACT_MODAL_NAME =
  'DELETE_GG_POINT_OF_CONTACT_MODAL_NAME';
